import React from 'react'
import { Music } from './Music';
import { Quote } from './Quote';
import { Tweet } from './Tweet';
import { Workout } from './Workout';
import { InfoSection, Bubble, DescriptionCard, InfoCircle} from '../common'

const StatisticItem = ({ title, infoDescription, footer, children }) =>{
  return(
    <Bubble>
      <div className='h-full flex flex-col justify-between'>

        <div className='flex flex-row justify-between mb-2 xl:mb-4 2xl:mb-6'>
          <DescriptionCard>{title}</DescriptionCard>
          {infoDescription && <InfoCircle description={infoDescription}/>}
        </div>

        {children}

        {footer && <div className='italic text-xs text-right xl:text-lg 2xl:text-2xl mt-2 xl:mt-4 2xl:mt-6 text-stone-800 dark:text-stone-100'>{footer}</div>}

      </div>
    </Bubble>
  )
}

export const Statistics = ({ currentDate, spotifyUrl, fitBitUrl, tweetUrl }) => {
  const monthName = currentDate.toLocaleString('en-US', { month: 'long' });

  const props_music = {
    title: monthName + "'s most listened song:",
    footer: "Powered by Spotify"
  }

  const props_random = {
    title: "Random:",
    footer: " "
  }

  const props_workout = {
    title: "Today's Fitness Summary:",
    infoDescription: "Data is updated in real time.",
    footer: "Powered by FitBit"
  }

  const props_tweet = {
    title: "Generate a Tweet:",
    footer: "Powered by HugginFace Space"
  }

  return (
    <InfoSection title='Statistics'>
      <div className='grid gap-4 xl:gap-10 2xl:gap-16 xl:grid-cols-2'> 
        <StatisticItem {...props_music}><Music targetUrl={spotifyUrl}/></StatisticItem>
        <StatisticItem {...props_random}><Quote/></StatisticItem>
        <StatisticItem {...props_workout}><Workout targetUrl={fitBitUrl} /></StatisticItem>
        <StatisticItem {...props_tweet}><Tweet currentDate={currentDate} targetUrl={tweetUrl} /></StatisticItem>
      </div> 
    </InfoSection>
  )
}